var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCosts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 9.8c.5-.7.8-1.5.8-2.3C22 4.4 17.6 2 12 2S2 4.4 2 7.5c0 .8.3 1.6.8 2.2-.5.7-.8 1.5-.8 2.3s.3 1.6.8 2.2c-.5.7-.8 1.5-.8 2.3C2 19.6 6.4 22 12 22s10-2.4 10-5.5c0-.8-.3-1.6-.8-2.2.5-.7.8-1.4.8-2.2s-.3-1.7-.8-2.3zM12 20c-4.7 0-8-1.8-8-3.5 0-.3.1-.6.3-.9 1.8 1.2 4.5 1.9 7.7 1.9s5.9-.8 7.7-1.9c.2.3.3.6.3.9 0 1.7-3.3 3.5-8 3.5zm7.7-7.1c-.3.5-.9.9-1.7 1.3-1.4.7-3.5 1.2-6 1.2s-4.6-.4-6-1.2c-.8-.4-1.3-.8-1.7-1.3-.2-.3-.3-.6-.3-.9s.1-.6.3-.9c.5.4 1.2.7 1.9.9 1.6.6 3.6 1 5.8 1s4.2-.4 5.8-1c.7-.3 1.3-.6 1.9-.9.2.3.3.6.3.9s-.1.6-.3.9zm0-4.5c-.3.5-.9.9-1.7 1.3-1.4.7-3.5 1.2-6 1.2s-4.6-.5-6-1.2c-.8-.3-1.3-.8-1.7-1.3-.2-.3-.3-.6-.3-.9C4 5.8 7.3 4 12 4s8 1.8 8 3.5c0 .3-.1.6-.3.9z",
    fill: "#050505"
  })));
}

export default SvgIconCosts;